import * as S from './styles'
import {FormCheckBoxParams} from "./types";


export const FormCheckBox = ({name, data, setValue}: FormCheckBoxParams) => {
    const checked = data[name];
    const handleClick = () => setValue(name, !checked);

    return (
        <S.FormCheckboxContainer>
            <S.StyledCheckbox checked={checked} onClick={handleClick}>
                <S.FormCheckBoxIcon viewBox="0 0 24 24">
                    <path fillRule="evenodd" clipRule="evenodd" d="M21.5365 0.684986C21.9401 1.06198 21.9617 1.69478 21.5847 2.09838L7.41616 17.2669C7.20608 17.4918 6.90413 17.6074 6.59755 17.5804C6.29097 17.5534 6.01392 17.3867 5.84643 17.1285L0.307115 8.58918C0.00655496 8.12584 0.138513 7.50658 0.601851 7.20602C1.06519 6.90546 1.68445 7.03742 1.98501 7.50076L6.828 14.9666L20.1231 0.733164C20.5001 0.329563 21.1329 0.307993 21.5365 0.684986Z" fill="#E0E0E0"/>
                </S.FormCheckBoxIcon>
            </S.StyledCheckbox>
        </S.FormCheckboxContainer>
    )
}